import React, { useState } from 'react';

function Login({ onLogin }) {
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedUser, setSelectedUser] = useState('');

  // Complete hierarchy structure
  const users = [
    // Super Admin - Can manage everything
    { 
      id: 1, 
      name: 'Super Admin', 
      role: 'Super Admin', 
      department: null,
      permissions: ['manage_admins', 'manage_departments', 'view_all_forms', 'view_all_submissions']
    },
    
    // Admins - Can create forms for their departments
    { 
      id: 2, 
      name: 'Admin A', 
      role: 'Admin', 
      department: 'Department A',
      permissions: ['create_forms', 'view_department_submissions']
    },
    { 
      id: 3, 
      name: 'Admin B', 
      role: 'Admin', 
      department: 'Department B',
      permissions: ['create_forms', 'view_department_submissions']
    },
    { 
      id: 4, 
      name: 'Admin C', 
      role: 'Admin', 
      department: 'Department C',
      permissions: ['create_forms', 'view_department_submissions']
    },
    
    // Department Users - Can only fill forms
    { 
      id: 5, 
      name: 'User A1', 
      role: 'Department User', 
      department: 'Department A',
      permissions: ['fill_forms', 'view_own_submissions']
    },
    { 
      id: 6, 
      name: 'User A2', 
      role: 'Department User', 
      department: 'Department A',
      permissions: ['fill_forms', 'view_own_submissions']
    },
    { 
      id: 7, 
      name: 'User B1', 
      role: 'Department User', 
      department: 'Department B',
      permissions: ['fill_forms', 'view_own_submissions']
    },
    { 
      id: 8, 
      name: 'User B2', 
      role: 'Department User', 
      department: 'Department B',
      permissions: ['fill_forms', 'view_own_submissions']
    },
    { 
      id: 9, 
      name: 'User C1', 
      role: 'Department User', 
      department: 'Department C',
      permissions: ['fill_forms', 'view_own_submissions']
    }
  ];

  const roles = ['Super Admin', 'Admin', 'Department User'];

  const handleLogin = () => {
    if (selectedRole && selectedUser) {
      const user = users.find(u => u.id === parseInt(selectedUser));
      
      // Store user data in localStorage
      localStorage.setItem('currentUser', JSON.stringify(user));
      
      onLogin(user);
    }
  };

  const filteredUsers = selectedRole 
    ? users.filter(u => u.role === selectedRole)
    : [];

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-md p-8 w-full max-w-md">
        
        <div className="mb-8">
          <h1 className="text-2xl font-semibold text-gray-800">Welcome</h1>
          <p className="text-gray-600 text-sm mt-1">Please login to continue</p>
        </div>

        <div className="space-y-5">
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Role
            </label>
            <select 
              value={selectedRole} 
              onChange={(e) => {
                setSelectedRole(e.target.value);
                setSelectedUser('');
              }}
              className="w-full px-4 py-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
            >
              <option value="">Select role</option>
              {roles.map(role => (
                <option key={role} value={role}>{role}</option>
              ))}
            </select>
          </div>

          {selectedRole && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                User
              </label>
              <select 
                value={selectedUser} 
                onChange={(e) => setSelectedUser(e.target.value)}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition"
              >
                <option value="">Select user</option>
                {filteredUsers.map(user => (
                  <option key={user.id} value={user.id}>
                    {user.name} {user.department ? `(${user.department})` : ''}
                  </option>
                ))}
              </select>
            </div>
          )}

          <button 
            onClick={handleLogin}
            disabled={!selectedRole || !selectedUser}
            className="w-full bg-blue-600 text-white py-2.5 rounded-md font-medium hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition mt-6"
          >
            Login
          </button>

        </div>

        {/* Hierarchy Info */}
        <div className="mt-8 p-4 bg-gray-50 rounded-md">
          <p className="text-xs font-semibold text-gray-700 mb-2">System Hierarchy:</p>
          <div className="text-xs text-gray-600 space-y-1">
            <p>🔹 <strong>Super Admin:</strong> Manages all admins & departments</p>
            <p>🔹 <strong>Admin:</strong> Creates forms for their department</p>
            <p>🔹 <strong>Department User:</strong> Fills forms</p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Login;